var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndiLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 40 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92419 2.50195L0.232813 5.0039V0L3.92419 2.50195ZM0.174805 7.33329H4.01171V31.49H0.174805V7.33329ZM6.88922 7.33329H11.6848L15.4053 21.7123V7.33329H18.9513V31.49H15.0271L10.4352 13.8614V31.49H7.03398L6.88922 7.33329ZM27.6711 7.33329H21.8579V31.49H27.6711C31.595 31.49 33.4843 29.3907 33.4843 25.5084V13.315C33.4843 9.43268 31.4787 7.33329 27.6711 7.33329ZM29.6183 25.6809C29.6183 27.4064 28.8919 28.0391 27.6711 28.0391H25.7239V10.7843H27.6711C28.8919 10.7843 29.6183 11.417 29.6183 13.1425V25.6809ZM35.9261 7.33329H39.7623V31.49H35.9261V7.33329Z",
    fill: "#FF4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndiLogo);
export default __webpack_public_path__ + "static/media/indi-logo.8bf10a56047fad720600f2af26f9bd3e.svg";
export { ForwardRef as ReactComponent };